import React from 'react';
import { Box } from '@mui/material';
import PersonsDashboard from '../../components/persona/PersonsDashboard';

const PersonasPage = () => {
  return (
    <Box sx={{ p: 2 }}>
      <PersonsDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de personas:', newOrder);
        }}
      />
    </Box>
  );
};

export default PersonasPage;